"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ScrollableColumns(_ref) {
  var scrollable = _ref.scrollable,
      columns = _ref.columns,
      mini = _ref.mini;
  if (!scrollable && !mini) return null;
  return /*#__PURE__*/_react.default.createElement("colgroup", null, columns.map(function (_ref2) {
    var width = _ref2.width,
        minWidth = _ref2.minWidth;
    return /*#__PURE__*/_react.default.createElement("col", {
      style: {
        width: width,
        minWidth: minWidth || width
      }
    });
  }));
}

ScrollableColumns.propTypes = {
  mini: _propTypes.default.bool,
  scrollable: _propTypes.default.bool,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    width: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    minWidth: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    hidden: _propTypes.default.bool,
    sortable: _propTypes.default.bool,
    className: _propTypes.default.string
  }))
};
ScrollableColumns.defaultProps = {
  mini: false,
  scrollable: false,
  columns: []
};
var _default = ScrollableColumns;
exports.default = _default;